import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class GetRolesCommand extends IRequestCommand<
  IGetRolesResponse[],
  ErrorDetails,
  IGetRolesParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'api/roles';

  public override setParameters(parameters: IGetRolesParameters) {
    const params: string[] = [];
    if (parameters.contractorId != null) {
      params.push(`contractorId=${parameters.contractorId}`);
    }
    if (parameters.apiRole) {
      params.push(`apiRole=${parameters.apiRole}`);
    }
    if (params.length > 0) {
      this._commandUrl += '?' + params.join('&');
    }
  }
}

export interface IGetRolesParameters extends ICommandParameters {
  contractorId: string | null;
  apiRole: string;
}

export interface IGetRolesResponse extends ICommandResponse {
  id: number;
  rolDescription: string;
}
